import { deleteBranch } from '../../../../actions/admin/branch';
import { basicMsg, simpleConfirmDialog } from '../../../../actions/swal_msg';

import { Menu, MenuItem } from '@mui/material';

import { BRANCH_EDIT } from '../../../../constants/admin/branch_constants';

const BranchItemMenu = ({
    anchorEl, setAnchorEl, activeBranch, setActiveBranch,
    setBranches, setLoading, setSnackbarData, handleClickModal
}) => {
    const { _id, name, folderId } = activeBranch;
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    // eliminar sucursal
    const deleteActiveBranch = async () => {
        handleClose();
        if (!_id) {
            basicMsg('Seleccione una sucursal');
            return;
        }
        
        if (await simpleConfirmDialog(`¿Desea eliminar ${name}?`, 'Sí, continuar')) {
            setLoading(true);
            if (await deleteBranch({ _id, folderId }, setSnackbarData)) {
                setActiveBranch(BRANCH_EDIT);
                setBranches(e => e.filter(branch => branch._id !== _id));
            }
            setLoading(false);
        }
    };
    
    return (
        <Menu
            id="branches-menu"
            anchorEl={ anchorEl }
            open={ open }
            onClose={ () => setAnchorEl(null) }
        >
            <MenuItem
                onClick={ handleClickModal }>
                Editar
            </MenuItem>
            <MenuItem onClick={ deleteActiveBranch }>
                Eliminar sucursal
            </MenuItem>
        </Menu>
    );
};

export default BranchItemMenu;